










































































import { Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { namespace } from 'vuex-class'
import { CredentialsType } from '@/api/types'
import { TypeformCredentials } from '@/api/model/credentials'
const referrals = namespace('referrals')
const orders = namespace('orders')

@Component
export default class Navigation extends Vue {
    @referrals.Action applySearch: ({ query }) => Promise<void>
    @referrals.Action('applyView') referralsApplyView: ({ view: ReferralView, direction: ReferralFilterDirection, update: boolean }) => Promise<void>
    @referrals.Getter('activeDirection') referralsActiveDirection: string
    @orders.Action('applyView') ordersApplyView: ({ view: OrderView, direction: OrderFilterDirection, update: boolean }) => Promise<void>
    @orders.Getter('activeDirection') ordersActiveDirection: string
    showSearch: boolean = false

    mounted() {
        this.setDefaultReferralsView()
        this.setDefaultOrdersView()
    }

    setDefaultReferralsView(): void {
        this.referralsApplyView({
            view: this.$currentUser.defaultDashboardView,
            direction: this.referralsActiveDirection || 'in',
            update: true,
        })
    }

    setDefaultOrdersView(): void {
        this.ordersApplyView({
            view: this.$currentUser.defaultDashboardView,
            direction: this.ordersActiveDirection || 'in',
            update: true,
        })
    }

    get companyEnabledOrders(): boolean {
        if (!this.$currentCompany.orderSettings) {
            return false
        }

        return this.$currentCompany.orderSettings.enabled
    }

    get companyEnabledTypeform(): boolean {
        const credentials = this.$currentCompany.getCredentialsWithType(CredentialsType.TYPEFORM) as TypeformCredentials[]
        if (credentials.length === 0) {
            return false
        }

        return credentials[0].workspaceId !== null
    }

    goToSearch(query: string): void {
        this.showSearch = false

        if (this.$route.name !== 'tasks_all') {
            this.$router.push({ name: 'tasks_all' })
        }

        this.applySearch({ query })
    }
}
